(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inovago-contact"] && !Shopify.designMode) return;
  try {
    
function prefillInovagoService(root){const requested=new URLSearchParams(location.search).get('service');if(!requested)return;root.querySelectorAll('.inv-contact select[name="contact[Besoin]"]').forEach(select=>{if(!select.value&&Array.from(select.options).some(option=>option.value===requested))select.value=requested;});}
prefillInovagoService(document);
document.addEventListener('shopify:section:load',event=>prefillInovagoService(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inovago-header"]) return;
  try {
    
function initStudioNavigation(root) {
 root.querySelectorAll('.studio-header').forEach(header => {
  if (header.dataset.ready) return;
  header.dataset.ready = 'true';
  const menus = Array.from(header.querySelectorAll('details'));
  menus.forEach(menu => menu.addEventListener('toggle', () => { if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; }); }));
  header.addEventListener('keydown', event => { if(event.key === 'Escape') menus.forEach(menu => { if(menu.open){menu.open = false;menu.querySelector('summary').focus();} }); });
  document.addEventListener('click', event => { menus.forEach(menu => { if(!menu.contains(event.target) || event.target.closest('a')) menu.open = false; }); });
  header.addEventListener('focusout', () => { setTimeout(() => { menus.forEach(menu => { if(!menu.contains(document.activeElement)) menu.open = false; }); }, 0); });
 });
}
initStudioNavigation(document);
document.addEventListener('shopify:section:load', event => initStudioNavigation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inovago-navigation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('inovago-navigation')) {
  customElements.define('inovago-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.panel = this.querySelector('.iv-navigation');
      this.opener = this.querySelector('[data-iv-open]');
      this.closer = this.querySelector('[data-iv-close]');
      this.disclosures = [...this.querySelectorAll('.iv-disclosure')];
      this.mobile = matchMedia('(max-width: 1319px)');
      this.inertElements = [];
      this.classList.add('iv-enhanced');
      this.opener.addEventListener('click', () => this.openMenu(), options);
      this.closer.addEventListener('click', () => this.closeMenu(), options);
      this.mobile.addEventListener('change', () => this.closeMenu(false), options);
      this.disclosures.forEach(details => {
        const summary = details.querySelector('summary');
        summary.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) this.disclosures.forEach(other => { if (other !== details) other.open = false; });
        }, options);
      });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeDisclosures();
      }, options);
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target) && !this.classList.contains('iv-open')) this.closeDisclosures();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const open = this.disclosures.find(details => details.open);
          if (open) { event.preventDefault(); open.open = false; open.querySelector('summary').focus(); }
          else if (this.classList.contains('iv-open')) { event.preventDefault(); this.closeMenu(); }
        }
        if (event.key === 'Tab' && this.classList.contains('iv-open')) {
          const focusable = [...this.panel.querySelectorAll('a[href],button:not([disabled]),summary')].filter(el => el.getClientRects().length);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const disclosure = event.target.closest('.iv-disclosure');
        if (this.mobile.matches) this.openMenu();
        if (disclosure) disclosure.open = true;
      }, options);
    }
    closeDisclosures() { this.disclosures.forEach(details => { details.open = false; }); }
    openMenu() {
      if (!this.mobile.matches || this.classList.contains('iv-open')) return;
      this.classList.add('iv-open');
      this.opener.setAttribute('aria-expanded', 'true');
      this.panel.setAttribute('role', 'dialog');
      this.panel.setAttribute('aria-modal', 'true');
      this.panel.setAttribute('aria-labelledby', this.querySelector('.iv-mobile-heading strong').id);
      this.savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      for (let element = this.panel; element.parentElement; element = element.parentElement) {
        for (const sibling of element.parentElement.children) {
          if (sibling !== element && !sibling.inert) { sibling.inert = true; this.inertElements.push(sibling); }
        }
        if (element.parentElement === document.body) break;
      }
      this.closer.focus();
    }
    closeMenu(restoreFocus = true) {
      this.closeDisclosures();
      if (!this.classList.contains('iv-open')) return;
      this.classList.remove('iv-open');
      this.opener.setAttribute('aria-expanded', 'false');
      this.panel.removeAttribute('role');
      this.panel.removeAttribute('aria-modal');
      this.panel.removeAttribute('aria-labelledby');
      this.inertElements.forEach(element => { element.inert = false; });
      this.inertElements = [];
      document.body.style.overflow = this.savedOverflow;
      if (restoreFocus && this.opener.getClientRects().length) this.opener.focus();
    }
    disconnectedCallback() {
      this.closeMenu(false);
      this.controller.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
